import queries from '@apis/queries';
import { PaymentMethod } from '@models/order';
import { useQuery } from '@tanstack/react-query';

function usePaymentMethods(): PaymentMethod[] {
    const { data } = useQuery(queries.paymentMethod.list());
    return [...(data?.paymentMethods || [])];
}

export default usePaymentMethods;
